/** 手机布局：工具栏允许换行，手写弹窗限制动态可视高度，避免窄屏和键盘弹出后遮住业务操作。 */
import React, { useEffect, useState } from "react";
import { useApp } from "../context/AppContext";
import { Crown, Trophy, Medal, Loader2, Zap } from "lucide-react";

export default function CRMHallOfFame() {
  const { api, lang } = useApp();
  const zh = lang === "zh";
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/crm/champions/hall").then(({ data }) => setData(data)).catch(() => setData({ timeline: [], winCounts: [], totalMonths: 0 })); }, []); // eslint-disable-line

  if (!data) return <div className="flex items-center justify-center py-32 text-slate-400"><Loader2 className="h-6 w-6 animate-spin" /></div>;
  const fmtH = (h) => h == null ? "—" : h >= 24 ? `${(h / 24).toFixed(1)}${zh ? "天" : "d"}` : `${h}${zh ? "小时" : "h"}`;

  return (
    <div className="max-w-4xl mx-auto" data-testid="crm-hall-of-fame">
      <div className="flex-wrap md:flex-nowrap flex items-center gap-2.5 mb-5">
        <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center shadow-sm"><Trophy className="h-5.5 w-5.5 text-white" /></div>
        <div>
          <h1 className="text-2xl font-bold text-slate-800">{zh ? "认领冠军荣誉墙" : "Claim Champions Hall of Fame"}</h1>
          <p className="text-[13px] text-slate-500">{zh ? "历届月度「认领竞速冠军」，荣誉长存。" : "Monthly claim-speed champions."}</p>
        </div>
      </div>

      {data.totalMonths === 0 ? (
        <div className="flex flex-col items-center justify-center py-24 text-slate-400" data-testid="hall-empty">
          <Crown className="h-10 w-10 mb-2" /><p className="text-sm">{zh ? "还没有产生冠军，快去公海认领客户吧！" : "No champions yet."}</p>
        </div>
      ) : (
        <div className="grid gap-6 lg:grid-cols-[1fr_260px]">
          <div>
            <p className="text-[13px] font-bold text-slate-600 mb-3">{zh ? "🏆 冠军时间线" : "🏆 Timeline"}</p>
            <div className="space-y-2.5">
              {data.timeline.map((t, i) => (
                <div key={i} className={`flex items-center gap-3 rounded-xl border p-3 ${i === 0 ? "border-amber-300 bg-gradient-to-r from-amber-50 to-white" : "border-slate-200 bg-white"}`} data-testid={`hall-row-${i}`}>
                  <div className="h-10 w-10 rounded-lg bg-amber-100 flex items-center justify-center shrink-0">
                    {i === 0 ? <Crown className="h-5 w-5 text-amber-500" /> : <Medal className="h-5 w-5 text-slate-400" />}
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-[14px] font-bold text-slate-800 truncate">{t.sales}</p>
                    <p className="text-[11px] text-slate-500">{t.month} · {t.claims} {zh ? "单认领" : "claims"} · {zh ? "平均" : "avg"} {fmtH(t.avgHours)}</p>
                  </div>
                  {t.fastestHours != null && <span className="text-[11px] text-orange-500 font-semibold inline-flex items-center gap-0.5 shrink-0"><Zap className="h-3 w-3" />{zh ? "最快" : "fastest"} {fmtH(t.fastestHours)}</span>}
                  {i === 0 && <span className="text-[10px] font-bold text-amber-600 bg-amber-100 px-2 py-0.5 rounded-full shrink-0">{zh ? "现任" : "Current"}</span>}
                </div>
              ))}
            </div>
          </div>
          <div>
            <p className="text-[13px] font-bold text-slate-600 mb-3">{zh ? "👑 夺冠榜" : "👑 Most Wins"}</p>
            <div className="rounded-xl border border-slate-200 bg-white p-3 space-y-2" data-testid="hall-wins">
              {data.winCounts.map((w, i) => (
                <div key={i} className="flex-wrap md:flex-nowrap flex items-center gap-2.5" data-testid={`win-row-${i}`}>
                  <span className="text-base w-6 text-center">{i === 0 ? "🥇" : i === 1 ? "🥈" : i === 2 ? "🥉" : i + 1}</span>
                  <span className="text-[13px] font-semibold text-slate-700 flex-1 truncate">{w.sales}</span>
                  <span className="text-[12px] font-bold text-amber-600">{w.wins} {zh ? "冠" : "×"}</span>
                  {w.wins >= 3 && <span title={zh ? "三冠王" : "3x"}>🔥</span>}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
